export default __webpack_public_path__ + "static/illustration-12th-grade-ced0bbf5577b87e67ce7b3d08a0167d9.svg";